import { useQueryClient } from "@tanstack/react-query";
import { UsersQueryParams } from "./admin/users";

export const QueryKeys = {
  adminDashboard: ["adminDashboard"],
  adminUsers: (params: UsersQueryParams) => ["adminUsers", params],
  adminCandidatePipeline: ["adminCandidatePipeline"],
  adminApprovedCandidates: ["adminApprovedCandidates"],
  adminReferences: ["adminReferences"],
  adminCompanies: ["adminCompanies"],
  adminCompany: (id: string) => ["adminCompanyDetails", id],
  adminJobPipeline: ["adminJobPipeline"],
  adminJobChecklist: ["adminJobChecklist"],
  adminJobDetails: (id: string) => ["adminJobDetails", id],
  adminSampleJobMatches: (params: {
    jobTitle: string;
    jobDescription: string;
  }) => ["adminJobDetails", params.jobTitle, params.jobDescription],
  venturiJobChat: (id: string) => ["venturiJobChat", id],
  venturiPublicChat: (id: string) => ["venturiPublicChat", id],
  adminContracts: ["adminContracts"],
  adminInvoices: ["adminInvoices"],
  adminPayments: ["adminPayments"],
  adminPayouts: ["adminPayouts"],
  stripeCustomerID: (isCompany: boolean) => [
    "stripe",
    "customerID",
    isCompany ? "company" : "user",
  ],
  stripePaymentMethod: (isCompany: boolean) => [
    "stripe",
    "paymentMethod",
    isCompany ? "company" : "user",
  ],
  stripeAccount: ["stripe", "accountID"],
  stripeAccountSessionSecret: (accountID: string) => [
    "stripe",
    "accountSessionSecret",
    accountID,
  ],
  myProfile: ["myProfile"],
  myCompany: (id: string) => ["myCompany", id],
  myCandidate: ["myCandidate"],
  candidate: (id: string) => ["candidate", id],
  companyOpportunities: ["companyOpportunities"],
  companyOpportunity: (id: string) => ["companyOpportunity", id],
  companyOpportunitySkills: (jobTitle: string) => [
    "companyOpportunitySkills",
    jobTitle,
  ],
  companyDraftJobDescriptions: (id: string) => ["companyOpportunitySkills", id],
  companyTeam: (id: string) => ["companyTeam", id],
  companyResources: ["companyResources"],
  candidateResources: ["candidateResources"],
  candidateOpportunities: ["candidateOpportunities"],
  candidateAvailability: (oid: string, iid: string) => [
    "candidateAvailability",
    oid,
    iid,
  ],
  candidateScreeningInterview: ["candidateScreeningInterview"],
  candidateOpportunityProfile: (id: string) => [
    "candidateOpportunityProfile",
    id,
  ],
  publicOpportunity: (id: string) => ["publicOpportunity", id],
  chatConversations: ["chat", "conversations"],
  chatMessage: (conversationId: string) => ["chat", conversationId, "message"],
};

export const useInvalidateQuery = () => {
  const qc = useQueryClient();

  const invalidate = async (queryKey: (string | number)[]) => {
    await qc.invalidateQueries({
      queryKey,
    });
  };

  return invalidate;
};
